<div class="custom-toast">
    <img src="../../../../../../assets/images/check_circle.png" class="image">
    <span>{{ data.message }}</span>
    <button (click)="close()" style="background: #DBF0DB !important;" class="close-button">
        <mat-icon class="close-icon">close</mat-icon>
    </button>
</div>